import React, { useEffect, useState } from "react";
import axios from "axios";
import { useLoader } from "../../../context/LoaderProvider.jsx";

const CatringsCoupons = () => {
    const [formData, setFormData] = useState({
        type: "",
        description: "",

        gole
            : "",
        startDate: "",
        endDate: "",
        discount: "",
        image: "",
    });

    const [couponRequests, setCouponRequests] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const isMobile = window.innerWidth <= 768;

    const [payNowModal, setPayNowModal] = useState(false);
    const [loadingDetail, setLoadingDetail] = useState(false);
    const [couponDetail, setCouponDetail] = useState(null);
    const [payNowAmount, setPayNowAmount] = useState("");
    const [loadingPayNow, setLoadingPayNow] = useState(false);
    const { showLoader, hideLoader } = useLoader();

    const [loading, setLoading] = useState(true);

    const tdStyle = {
        border: "1px solid #ccc",
        padding: "10px",
        textAlign: "left",
    };



    const [selectedCouponId, setSelectedCouponId] = useState(null);



    const handleRazorpayPayment = async () => {
        try {
            const vendorId = localStorage.getItem("vendorId");
            const token = localStorage.getItem("authToken");
            showLoader();
            if (!vendorId || !token) {
                alert("⚠️ Missing vendor ID or auth token. Please login again.");
                return;
            }

            if (!selectedCouponId) {
                alert("⚠️ No coupon selected. Please select a coupon before proceeding.");
                return;
            }

            const payNowAmountInPaise = Math.round(payNowAmount * 100);

            // STEP 1: Create Razorpay order
            const createOrderRes = await axios.post(
                "http://testing.maamaas.com:8080/catering/api/payments/create-order/user",
                {
                    amount: payNowAmount,
                    currency: "INR",
                    vendorId,
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "application/json",
                        Accept: "application/json",
                    },
                }
            );

            const { orderId } = createOrderRes.data;
            if (!orderId) throw new Error("Order ID not received from backend");

            const options = {
                key: "rzp_live_RU5whSMu9rPV7s",
                amount: payNowAmountInPaise,
                currency: "INR",
                name: "Maamaa's House",
                description: "Coupon Payment",
                order_id: orderId,
                handler: async (response) => {
                    const paymentId = response.razorpay_payment_id;
                    const razorpayOrderId = response.razorpay_order_id;

                    if (!paymentId || !razorpayOrderId) {
                        alert("⚠️ Payment ID or Order ID missing.");
                        return;
                    }

                    try {
                        // STEP 3: Capture payment
                        await axios.post(
                            "http://testing.maamaas.com:8080/catering/api/payments/capture",
                            {
                                paymentId,
                                amount: payNowAmount,
                                currency: "INR",
                                vendorId,
                            },
                            {
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                    "Content-Type": "application/json",
                                    Accept: "application/json",
                                },
                            }
                        );

                        // STEP 4: Update coupon payment
                        const updateRes = await axios.put(
                            "http://testing.maamaas.com:8080/catering/api/vendor/catering/coupon/updatePayment",
                            null,
                            {
                                params: {
                                    vendorCouponId: selectedCouponId, // ✅ ensure this is defined
                                    transactionId: paymentId,
                                    orderId: razorpayOrderId,
                                },
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                    Accept: "application/json",
                                },
                            }
                        );

                        alert("✅ Payment successful and updated!");
                        setPayNowModal(false);
                    } catch (err) {
                        console.error("❌ Payment capture/update failed:", err.response?.data || err);
                        alert("⚠️ Payment captured but update failed.");
                    }

                },
                prefill: {
                    name: "Customer Name",
                    email: "customer@example.com",
                    contact: "9999999999",
                },
                theme: { color: "#b15cd6" },
            };

            const rzp = new window.Razorpay(options);
            rzp.open();
        } catch (error) {
            console.error("❌ Razorpay initialization error:", error);
            alert("⚠️ Payment failed to initialize. Check console for details.");
        }
        finally {
            hideLoader();
        }
    };






    const openCouponDetailModal = async (couponId) => {
        try {
            // alert(`Coupon ID: ${couponId}`); // ✅ shows correct ID
            setSelectedCouponId(couponId);   // ✅ store it here
            setLoadingDetail(true);

            const token = localStorage.getItem("authToken");

            const response = await axios.get(
                `http://testing.maamaas.com:8080/catering/api/vendor/catering/coupon/get/${couponId}`,
                {
                    headers: {
                        accept: "*/*",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            setCouponDetail(response.data);
            setPayNowAmount(response.data.amount);
            setPayNowModal(true);
        } catch (error) {
            console.error("❌ Error fetching coupon detail:", error);
            alert("Failed to fetch coupon details by ID");
        } finally {
            setLoadingDetail(false);
        }
    };







    // ✅ Fetch coupons on mount
    // ✅ Fetch coupons on mount
    useEffect(() => {
        const fetchCoupons = async () => {
            try {
                showLoader();
                const token = localStorage.getItem("authToken");
                const vendorId = localStorage.getItem("vendorId");

                if (!token || !vendorId) {
                    alert("Missing vendor session. Please log in again.");
                    setLoading(false);
                    return;
                }

                // ✅ Change POST → GET (backend expects GET) 
                const response = await axios.get(
                    `http://testing.maamaas.com:8080/catering/api/vendor/catering/coupon/getByVendor/${vendorId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            Accept: "*/*",
                        },
                    }
                );

                setCouponRequests(response.data || []);
            } catch (error) {
                console.error("❌ Error fetching coupons:", error);
                if (error.response) {
                    console.error("📩 Response error data:", error.response.data);
                }
                alert("Failed to fetch coupon requests");
            } finally {
                setLoading(false);
                hideLoader();
            }
        };

        fetchCoupons();
    }, []);


    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };


    const handleImageUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData((prev) => ({
                ...prev,
                image: file, // ✅ store File directly
            }));
        }
    };



    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const authtoken = localStorage.getItem("authToken");
            const vendorId = localStorage.getItem("vendorId");

            if (!authtoken || !vendorId) {
                alert("Missing vendor session. Please log in again.");
                return;
            }

            // ✅ Build couponData JSON object
            const couponData = {
                vendorRequirementCouponId: 0,
                couponCode: formData.type?.toUpperCase().slice(0, 6) || "DEFAULT",
                discount: Number(formData.discount) || 0,
                startDate: new Date(formData.startDate).toISOString(),
                endDate: new Date(formData.endDate).toISOString(),
                description: formData.description || "",
                goal: formData.goal || "",
                amount: 0,
                paymentStatus: "PENDING",
                vendorId: vendorId,
                transactionId: "string",
                orderId: "string",
            };

            // ✅ Prepare FormData (MUST use this exact format)
            const formDataToSend = new FormData();
            formDataToSend.append(
                "couponData",
                new Blob([JSON.stringify(couponData)], { type: "application/json" })
            );

            // ✅ Append image (File input only)
            if (formData.image instanceof File) {
                formDataToSend.append("image", formData.image);
            } else {
                alert("Please select an image file");
                return;
            }

            // ✅ Debug — check form data entries
            

            // ✅ Send request
            const response = await axios.post(
                `http://testing.maamaas.com:8080/catering/api/vendor/catering/coupon/add/${vendorId}`,
                formDataToSend,
                {
                    headers: {
                        Authorization: `Bearer ${authtoken}`,
                        // ❌ DO NOT manually set Content-Type
                    },
                }
            );

            alert("Coupon created successfully!");

            setFormData({
                type: "",
                description: "",
                goal: "",
                startDate: "",
                endDate: "",
                discount: "",
                image: "",
            });
            setShowModal(false);
        } catch (error) {
            console.error("❌ Error:", error.response?.data || error.message);
            alert("Failed to submit coupon. Check console for details.");
        } finally {
            hideLoader();
        }
    };






    return (
        <div
            style={{
                // padding: '20px',
                maxWidth: '1200px',
                margin: isMobile ? '0px 0 0 0px' : '0px auto',
                boxSizing: 'border-box',
                position: 'relative',
                width: '100%',
            }}
        >
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '10px'
            }}>
                <button
                    style={{
                        padding: '10px 16px',
                        backgroundColor: '#1976d2',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                        fontSize: 'clamp(12px, 2vw, 14px)',
                    }}
                    onClick={() => setShowModal(true)}
                >
                    + Request Coupon
                </button>
            </div>

            {/* Table Section */}
            <div style={{
                marginTop: '0px',
                overflowX: 'auto',
                width: '100%'
            }}>
                <div style={{
                    minWidth: '800px',
                    width: '100%'
                }}>
                    <table
                        style={{
                            width: "100%",
                            borderCollapse: "collapse",
                            backgroundColor: "white",
                            border: "1px solid #ccc",
                        }}
                    >
                        <thead>
                            <tr>
                                {[
                                    "S.No",
                                    "Code",
                                    "Description",
                                    "Image",
                                    "Goal",
                                    "Start Date",
                                    "End Date",
                                    "Discount",
                                    "Amount",
                                    "Status",
                                    "Action",
                                ].map((head, i) => (
                                    <th
                                        key={i}
                                        style={{
                                            border: "1px solid #ccc",
                                            padding: "10px",
                                            backgroundColor: "#b15cd6",
                                            fontSize: "clamp(10px, 2vw, 14px)",
                                            textAlign: "left",
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        {head}
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="9" style={{ textAlign: "center", padding: "12px" }}>
                                        Loading...
                                    </td>
                                </tr>
                            ) : couponRequests.length === 0 ? (
                                <tr>
                                    <td colSpan="9" style={{ textAlign: "center", padding: "12px" }}>
                                        No requests yet.
                                    </td>
                                </tr>
                            ) : (
                                couponRequests.map((request, index) => (
                                    <tr key={index}>
                                        <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
                                            {index + 1}
                                        </td>
                                        <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
                                            {request.couponCode}
                                        </td>
                                        <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
                                            {request.description}
                                        </td>
                                        <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
                                            {request.image ? (
                                                <img
                                                    src={request.image} // 👈 show base64 as image
                                                    alt="Coupon"
                                                    style={{
                                                        width: "60px",
                                                        height: "60px",
                                                        objectFit: "cover",
                                                        borderRadius: "6px",
                                                        border: "1px solid #ccc",
                                                    }}
                                                />
                                            ) : (
                                                "No Image"
                                            )}
                                        </td>

                                        <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
                                            {request.goal || "N/A"}
                                        </td>
                                        <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
                                            {new Date(request.startDate).toLocaleDateString("en-GB")}
                                        </td>
                                        <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
                                            {new Date(request.endDate).toLocaleDateString("en-GB")}
                                        </td>

                                        <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
                                            {request.discount}%
                                        </td>
                                        <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
                                            {request.amount}
                                        </td>
                                        <td style={{ ...tdStyle, fontSize: "clamp(10px, 2vw, 14px)" }}>
                                            {request.paymentStatus || "Pending"}
                                        </td>
                                        <td>
                                            {request.paymentStatus === "SUCCESS" ? (
                                                <button
                                                    style={{
                                                        backgroundColor: "gray",
                                                        color: "white",
                                                        border: "none",
                                                        padding: "6px 12px",
                                                        borderRadius: "6px",
                                                        cursor: "not-allowed",
                                                    }}
                                                    disabled
                                                >
                                                    Paid
                                                </button>
                                            ) : (
                                                <button
                                                    style={{
                                                        backgroundColor: "#b15cd6",
                                                        color: "white",
                                                        border: "none",
                                                        padding: "6px 12px",
                                                        borderRadius: "6px",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={() => openCouponDetailModal(request.vendorCouponId)}

                                                >
                                                    Pay Now
                                                </button>
                                            )}
                                        </td>



                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
            </div>


            {payNowModal && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        height: '100vh',
                        width: '100vw',
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 1000,
                    }}
                >
                    <div
                        style={{
                            backgroundColor: '#fff',
                            padding: '20px',
                            borderRadius: '10px',
                            width: '90%',
                            maxWidth: '400px',
                            boxSizing: 'border-box',
                        }}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h3 style={{ fontSize: 'clamp(16px, 3vw, 20px)', fontWeight: 'bold' }}>Pay Now</h3>
                            <button
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    fontSize: '18px',
                                    cursor: 'pointer',
                                }}
                                onClick={() => setPayNowModal(false)}
                            >
                                ✕
                            </button>
                        </div>

                        <div style={{ marginTop: '16px', display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            {loadingPayNow ? (
                                <p>Loading amount...</p>
                            ) : (
                                <label style={labelStyle}>
                                    Amount
                                    <input
                                        type="number"
                                        value={payNowAmount}
                                        readOnly
                                        style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
                                    />
                                </label>
                            )}

                            <button
                                style={{
                                    padding: '12px',
                                    backgroundColor: '#1976d2',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    width: 'fit-content',
                                    fontSize: 'clamp(12px, 2vw, 14px)'
                                }}
                                onClick={handleRazorpayPayment} // ✅ call payment function
                            >
                                Proceed to Pay
                            </button>

                        </div>
                    </div>
                </div>
            )}



            {/* Modal Popup */}
            {showModal && (
                <div
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        height: '100vh',
                        width: '100vw',
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 1000,
                    }}
                >
                    <div
                        style={{
                            backgroundColor: '#fff',
                            padding: '20px',
                            borderRadius: '10px',
                            width: '90%',
                            maxWidth: '600px',
                            maxHeight: '90vh',
                            overflowY: 'auto',
                            boxSizing: 'border-box',
                        }}
                    >
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <h3 style={{ fontSize: 'clamp(16px, 3vw, 20px)', fontWeight: 'bold' }}>Request a Coupon</h3>
                            <button
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    fontSize: '18px',
                                    cursor: 'pointer',
                                }}
                                onClick={() => setShowModal(false)}
                            >
                                ✕
                            </button>
                        </div>

                        <form onSubmit={handleSubmit} style={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '12px',
                            marginTop: '16px'
                        }}>
                            <input
                                type="text"
                                name="type"
                                placeholder="Coupon Type"
                                value={formData.type}
                                onChange={handleChange}
                                required
                                style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
                            />
                            <textarea
                                name="description"
                                placeholder="Description"
                                value={formData.description}
                                onChange={handleChange}
                                rows="3"
                                required
                                style={{ ...inputStyle, resize: 'vertical', fontSize: 'clamp(12px, 2vw, 14px)' }}
                            />
                            <input
                                type="text"
                                name="gole"
                                placeholder="Goal (e.g., Increase Leads)"
                                value={formData.gole}
                                onChange={handleChange}
                                required
                                style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
                            />

                            <div style={{
                                display: 'flex',
                                flexDirection: window.innerWidth < 480 ? 'column' : 'row',
                                gap: '12px'
                            }}>
                                <div style={{ flex: 1 }}>
                                    <label style={labelStyle}>
                                        Start Date
                                        <input
                                            type="date"
                                            name="startDate"
                                            value={formData.startDate}
                                            onChange={handleChange}
                                            required
                                            style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
                                        />
                                    </label>
                                </div>
                                <div style={{ flex: 1 }}>
                                    <label style={labelStyle}>
                                        End Date
                                        <input
                                            type="date"
                                            name="endDate"
                                            value={formData.endDate}
                                            onChange={handleChange}
                                            required
                                            style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
                                        />
                                    </label>
                                </div>
                            </div>

                            <input
                                type="number"
                                name="discount"
                                placeholder="Discount (%)"
                                value={formData.discount}
                                onChange={handleChange}
                                required
                                style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
                            />
                            <input
                                type="file"
                                accept="image/*"
                                onChange={handleImageUpload}
                                style={{ ...inputStyle, fontSize: 'clamp(12px, 2vw, 14px)' }}
                            />

                            <button
                                type="submit"
                                style={{
                                    padding: '12px',
                                    backgroundColor: '#1976d2',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    border: 'none',
                                    borderRadius: '6px',
                                    cursor: 'pointer',
                                    width: 'fit-content',
                                    fontSize: 'clamp(12px, 2vw, 14px)'
                                }}
                            >
                                Submit Request
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

// Reusable styles
const inputStyle = {
    padding: '10px',
    border: '1px solid #ccc',
    borderRadius: '6px',
    width: '100%',
    boxSizing: 'border-box',
};

const labelStyle = {
    fontSize: 'clamp(12px, 2vw, 14px)',
    marginBottom: '4px',
    display: 'block',
};

const tdStyle = {
    padding: '10px',
    border: '1px solid #ccc',
    textAlign: 'left',
};

export default CatringsCoupons;